import {
  getInfoCustomer,
  requestLoginOtp as requestOtpService,
  verifyOtpAndLogin as verifyOtpService,
} from '@/features/auth/services'
import { setCookies } from '@/libs/cookies'
import yup from '@/utils/yup-global'
import { otpRequestSchema, otpVerifySchema } from '@/validations'

/**
 * Server action để gửi mã OTP đến số điện thoại
 */
export const RequestOtpAction = async (values: yup.InferType<typeof otpRequestSchema>) => {
  try {
    const result = await requestOtpService(values.phone)
    console.log('RequestOtpAction result:', result)

    return result
  } catch (error) {
    console.error('RequestOtpAction error:', error)
    return { status: 'error', message: 'Có lỗi xảy ra khi gửi mã OTP' }
  }
}

/**
 * Server action để xác thực OTP và đăng nhập
 */
export const VerifyOtpAction = async (
  values: yup.InferType<typeof otpVerifySchema>,
  callbackUrl?: string | null
) => {
  try {
    // Xác thực OTP và nhận token
    const otpResult = await verifyOtpService(values.phone, values.otp)

    if (otpResult?.status === 'error') {
      return otpResult
    }

    const token = otpResult?.data?.token
    if (!token) {
      return { status: 'error', message: 'Không thể lấy token xác thực' }
    }

    // Lưu token vào cookies
    await setCookies(token)

    // Lấy thông tin user
    const infoUser = await getInfoCustomer()
    if (!infoUser) {
      return { status: 'error', message: 'Không thể lấy thông tin người dùng' }
    }

    return {
      status: 'success',
      data: infoUser,
    }
  } catch (error) {
    console.error('VerifyOtpAction error:', error)
    return { status: 'error', message: error instanceof Error ? error.message : '' }
  }
}
